import { simpleGqlClient } from '@/graphql/simple-client.jsx';

const q = async (query, variables = {}) => {
  const result = await simpleGqlClient.query(query, variables);
  if (result.errors?.length) throw new Error(result.errors[0].message);
  return result.data;
};

export const fetchGerencialResumen = (filters) => q(
  `query($sucursalId: ID, $lineaId: ID, $desde: String, $hasta: String){
    gerencialResumen(sucursalId:$sucursalId,lineaId:$lineaId,desde:$desde,hasta:$hasta){
      fechaDesde fechaHasta sucursalId lineaId guiasEmitidas guiasRecibidas guiasEnReparto guiasEntregadas guiasRetenidas
      totalKilos totalValorDeclarado totalFleteFacturado totalCR totalLiquidaciones margenEstimado margenReal
    }
  }`,
  filters,
).then((d) => d.gerencialResumen);

export const fetchGerencialSerie = (filters) => q(
  `query($sucursalId: ID, $lineaId: ID, $desde: String, $hasta: String, $granularidad: String){
    gerencialSerie(sucursalId:$sucursalId,lineaId:$lineaId,desde:$desde,hasta:$hasta,granularidad:$granularidad){
      fecha guias entregadas retenidas flete cr margenEstimado margenReal
    }
  }`,
  filters,
).then((d) => d.gerencialSerie || []);

export const fetchGerencialTopClientes = (filters) => q(
  `query($sucursalId: ID, $lineaId: ID, $desde: String, $hasta: String, $orderBy: String){
    gerencialTopClientes(sucursalId:$sucursalId,lineaId:$lineaId,desde:$desde,hasta:$hasta,orderBy:$orderBy){
      clienteId nombre guias flete cr margen
    }
  }`,
  filters,
).then((d) => d.gerencialTopClientes || []);

export const fetchGerencialTopLineas = (filters) => q(
  `query($sucursalId: ID, $desde: String, $hasta: String){
    gerencialTopLineas(sucursalId:$sucursalId,desde:$desde,hasta:$hasta){
      lineaId nombre guias flete cr margen
    }
  }`,
  filters,
).then((d) => d.gerencialTopLineas || []);

export const fetchGerencialAlertas = (filters) => q(
  `query($sucursalId: ID, $estado: String, $severidad: String){
    gerencialAlertas(sucursalId:$sucursalId,estado:$estado,severidad:$severidad){
      id tipo severidad titulo detalle payloadJson estado createdAt
    }
  }`,
  filters,
).then((d) => d.gerencialAlertas || []);

export const recomputarKpiDiario = (filters) => q(
  `mutation($desde: String!, $hasta: String!, $sucursalId: ID, $lineaId: ID){
    recomputarKpiDiario(desde:$desde,hasta:$hasta,sucursalId:$sucursalId,lineaId:$lineaId)
  }`,
  filters,
).then((d) => d.recomputarKpiDiario);

export const cerrarAlerta = (id) => q(
  `mutation($id: ID!){ cerrarAlerta(id:$id) }`,
  { id },
).then((d) => d.cerrarAlerta);
